import alt from 'framework/alt';
import PreferenceActions from 'actions/PreferenceActions';

class PreferenceStore {
  constructor() {
    this.state = {
      currentAuthorId: undefined,
      emailSubscriber: undefined,
      locale: undefined,
      error: undefined,
      isLoading: false,
    };

    this.on('bootstrap', () => {
      const { preferences } = this.state;

      this.setState({
        currentAuthorId: preferences.currentAuthorId,
        emailSubscriber: preferences.emailSubscriber,
        locale: preferences.locale,
        error: preferences.error,
        isLoading: false,
      });

      delete this.state.preferences;
    });

    this.bindListeners({
      fail: [PreferenceActions.updateFailed],
      put: [PreferenceActions.updateSucceeded],
      started: [PreferenceActions.updateStarted],
    });
  }

  started() {
    this.setState({
      error: null,
      isLoading: true,
    });
  }

  fail(err) {
    this.setState({
      error: err,
      isLoading: false,
    });
  }

  put(response) {
    let { emailSubscriber } = this.state;
    if (response.emailSubscriber !== emailSubscriber) {
      ({ emailSubscriber } = response);
    }

    let { locale } = this.state;
    if (response.locale !== locale) {
      ({ locale } = response);
    }

    let { currentAuthorId } = this.state;
    if (response.currentAuthorId !== currentAuthorId) {
      ({ currentAuthorId } = response);
    }

    this.setState({
      currentAuthorId,
      emailSubscriber,
      locale,
      error: null,
      isLoading: false,
    });
  }
}

export default alt.createStore(PreferenceStore, 'PreferenceStore');
